import { Container } from '@magnetic/container'
import { Flex } from '@magnetic/flex'
import { Heading } from '@magnetic/heading'
import { Text } from '@magnetic/text'
import { Card } from '@magnetic/card'
import { Button } from '@magnetic/button'
import { useToast } from '@magnetic/notification'
import { AuditLogsTable } from '@/components/audit-logs-table'
import { getAuditLogs } from '@/lib/api'
import { ClockCounterClockwise, Export } from '@/lib/icons'

export function AdminAuditLogsPage() {
  const { addToast } = useToast()

  const handleExport = () => {
    // TODO: Implement export functionality
    // For now, show a toast
    addToast({
      status: 'information',
      title: 'Export started',
      children: 'Audit logs are being exported. This may take a moment...',
    })

    // In a real implementation, you would:
    // 1. Fetch all logs (or filtered logs) from the backend
    // 2. Convert to CSV format
    // 3. Trigger browser download
    // Example:
    // const csv = convertLogsToCSV(logs)
    // const blob = new Blob([csv], { type: 'text/csv' })
    // const url = window.URL.createObjectURL(blob)
    // const a = document.createElement('a')
    // a.href = url
    // a.download = `audit-logs-${new Date().toISOString()}.csv`
    // a.click()
  }

  return (
    <Container>
      <Flex direction="vertical" gap={24} style={{ padding: '24px 0' }}>
        {/* Page Header */}
        <Flex direction="vertical" gap={4}>
          <Flex align="center" gap={8}>
            <ClockCounterClockwise size={24} weight="bold" />
            <Heading size="h1">Audit Logs</Heading>
          </Flex>
          <Text color="light">
            Track all actions and events across the platform
          </Text>
        </Flex>

        {/* Audit Logs Table */}
        <Card style={{ boxShadow: 'none' }}>
          <AuditLogsTable
            queryFn={getAuditLogs}
            configComponents={
              <Button
                kind="secondary"
                icon={<Export size={16} weight="bold" />}
                onClick={handleExport}
              >
                Export
              </Button>
            }
          />
        </Card>
      </Flex>
    </Container>
  )
}
